import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import * as fromStore from '../store';
import { Observable, Subscription } from 'rxjs';
import { DownloadSummarySearchRequest, LoadSummaryRequest } from '../models';

@Component({
  selector: 'app-contract-summary-search',
  templateUrl: './contract-summary-search.component.html'
})
export class ContractSummarySearchComponent {
  hasSubmitted: boolean;

  form: FormGroup;
  summarySearchState$: Observable<fromStore.SummarySearchState>;

  private _subscription: Subscription;
  private _searchCriteria: DownloadSummarySearchRequest;

  constructor(private _store: Store<fromStore.ContractDetailsState>, private fb: FormBuilder, private router: Router) {}

  ngOnInit() {
    this.summarySearchState$ = this._store.pipe(select(fromStore.getContractSummarySearchState));

    this._subscription = this.summarySearchState$.subscribe(s => {
      this._searchCriteria = s.searchCriteria;
    });
    const minimumDate = new Date('1900-01-01T00:00:00.000Z');
    const defaultEffectiveFrom = minimumDate.toISOString().slice(0, 16);

    const defaultFromDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().slice(0, 16);
    const defaultToDate = new Date().toISOString().slice(0, 16);

    this.form = this.fb.group({
      fromDate: [this._searchCriteria.fromDate ?? defaultFromDate], // last 7 days
      toDate: [this._searchCriteria.toDate ?? defaultToDate],
      effectiveFrom: [this._searchCriteria.effectiveFrom ?? defaultEffectiveFrom],
      orderId: [this._searchCriteria.orderId ?? ''],
      contractId: [this._searchCriteria.contractId ?? ''],
      contractNumber: [this._searchCriteria.contractNumber ?? null],
      sort: ['CreatedDateTime:Desc'],
      take: [15],
      skip: [0]
    });
  }

  onDestroy() {
    this._subscription.unsubscribe();
  }

  /**
   * Submits the form and navigates to the contract summary page with
   * the query parameters set from the form values.
   */
  onSearch() {
    if (this.form.invalid) return;

    // Our query we'll fill in later
    const summaryRequest: LoadSummaryRequest = {
      fromDate: null,
      toDate: null,
      contractNumber: null,
      orderId: null,
      contractId: null,
      effectiveFrom: null,
      skip: null,
      take: null,
      sort: null
    };

    Object.keys(this.form.controls).forEach(key => {
      const value = this.form.get(key).value;
      summaryRequest[key] = value;
    });
    this.hasSubmitted = true;

    this._store.dispatch(new fromStore.ExecuteContractSearch(summaryRequest));
  }

  onDownload() {
    const request: DownloadSummarySearchRequest = this.form.value;
    this._store.dispatch(new fromStore.DownloadSummarySearch(request));
  }
}
